import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import { useSelector } from "react-redux";
import { selectUserRole } from "../../../core/data/slice/authSlice";
import { useMemo } from "react";

const Error401 = () => {
  const routes = all_routes;
  const navigate = useNavigate();
  const location = useLocation();
  const userRole = useSelector(selectUserRole);
  
  // Check if button should be hidden based on router state or query param
  const hideBtn = location.state?.hideBtn || new URLSearchParams(location.search).get('public') === 'true';
  
  // Get dashboard path based on role
  const dashboardPath = useMemo(() => {
    switch(userRole) {
      case 'superadmin': return routes.adminDashboard;
      case 'centeradmin': return routes.centerDashboard;
      case 'teacher': return routes.teacherDashboard;
      default: return routes.login;
    }
  }, [userRole]);

  return (
    <div>
      <div className="row justify-content-center">
        <div className="col-xxl-6 col-xl-7 col-md-6">
          <div className="d-flex flex-column justify-content-between vh-100">
            <div className="text-center p-4">
              <ImageWithBasePath
                src="assets/img/logo.png"
                alt="img"
                className="img-fluid"
              />
            </div>
            <div className="d-flex flex-column justify-content-center align-items-center mb-4">
              <div className="mb-4">
                <ImageWithBasePath
                  src="assets/img/authentication/error-401.svg"
                  className="error-img img-fluid"
                  alt="Unauthorized Access"
                />
              </div>
              <h3 className="h2 mb-3">Access Denied</h3>
              <p className="text-center">
                Error 401: Unauthorized. You don't have permission to access this page.
              </p>
              {!hideBtn && (
                <button 
                  onClick={() => navigate(dashboardPath)}
                  className="btn btn-primary d-flex align-items-center"
                >
                  <i className="ti ti-arrow-left me-2" />
                  Return to Dashboard
                </button>
              )}
            </div>
            <div className="text-center p-4">
              <p>Copyright © {new Date().getFullYear()} - Aloha</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Error401;
